import React, {forwardRef} from 'react'
import {Skeleton, useStyleConfig} from '@chakra-ui/react'

const ReviewOverviewSkeleton = forwardRef((props, ref) => {
    const styles = useStyleConfig('ReviewOverview', props)

    return <Skeleton {...styles.skeleton} ref={ref} />
})

if (process.env.NODE_ENV !== 'production') {
    ReviewOverviewSkeleton.displayName = 'ReviewOverviewSkeleton'
}

export default ReviewOverviewSkeleton
